module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Carla Cassidy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Carla Cassidy is a "), _c('I', [_vm._v("New York Times ")]), _vm._v("bestselling author who has written more than 125 novels for Harlequin Books.  She is listed on the Romance Writer's of America Honor Roll and has won numerous awards. Carla believes the only thing better than curling up with a good book to read is sitting down at the computer with a good story to write.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Hu84NU/tc-custom/9781459220966.jpg?1723231592707",
      "alt": "This image is the cover for the book Scene of the Crime: Mystic Lake"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Scene of the Crime: Mystic Lake\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A killer changes the rules in the middle of the game in this riveting romantic suspense thriller from the "), _c('i', [_vm._v("New York Times")]), _vm._v("–bestselling author.")]), _c('br'), _c('br'), _vm._v("When FBI profiler Amberly Nightsong is sent to Mystic Lake to consult with local cops about three ritualistic murders, the last thing she expects is to be a piece in a madman’s sick puzzle. Luckily, she has a sexy lawman on her side."), _c('br'), _c('br'), _vm._v("Sheriff Cole Caldwell offers his protection—and stirs an awareness that leaves her breathless."), _c('br'), _c('br'), _vm._v("Cole, a widower, had shut himself off from the possibility of loving again. But as he works side by side with the single mom, he’s drawn to Amberly and will do anything to erase the fear in her eyes. And as the danger intensifies in the form of a killer’s twisted calling card, his vow to keep her and her young son safe will be put to the ultimate test . . .\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0